function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "37.072%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F0F0F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  stroke: "#BEBFCB",
  d: "M21.311 24.617a5.45 5.45 0 0 1-2.237-1.116L2.12 23.5A1.62 1.62 0 0 0 .5 25.12v3.76c0 .895.725 1.62 1.62 1.62h19.31a4.077 4.077 0 0 1-.119-.98v-4.903zm-4.186-13.118L2.12 11.5A1.62 1.62 0 0 0 .5 13.12v3.76c0 .895.725 1.62 1.62 1.62l15.005-.001v-7zm5.973.552v4.31c.002.653.026 1.12.089 1.477.2-.272.313-.605.313-.958v-3.76c0-.405-.15-.78-.402-1.069zM21.88.5H2.12A1.62 1.62 0 0 0 .5 2.12v3.76c0 .895.725 1.62 1.62 1.62h19.76a1.62 1.62 0 0 0 1.62-1.62V2.12A1.62 1.62 0 0 0 21.88.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A7B8E",
  d: "M17 26a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h10zm-.5-12v2H7a1 1 0 0 1 0-2h9.5zM17 3a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2h10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#498FFF",
  d: "M4 24v6H2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2zM4 1v6H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D01E29",
  d: "M4 12v6H2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#498FFF",
  d: "M29.3 25.68a1.618 1.618 0 0 0-1.567 1.124 1.558 1.558 0 0 0 .673 1.779c-.076.927-.818 1.67-1.768 1.772-1.002 0-1.814-1.02-1.814-2.278V22.97c2.408-.403 4.169-2.433 4.17-4.81v-5.955a2.26 2.26 0 0 0-.544-.176 1.493 1.493 0 0 0-1.67.867c-.27.641-.035 1.38.562 1.758v3.506c0 1.789-1.49 3.239-3.329 3.239-1.838 0-3.328-1.45-3.328-3.239v-3.506c.394-.277.63-.719.635-1.191a1.454 1.454 0 0 0-1.188-1.434c-.375-.074-.798.114-1.108.294-.032 0-.032 1.946 0 5.837.001 2.372 1.754 4.401 4.155 4.81v5.107c0 2.159 1.569 3.923 3.497 3.923 1.853-.12 3.329-1.555 3.451-3.358a1.564 1.564 0 0 0 .824-1.782 1.615 1.615 0 0 0-1.589-1.195l-.061.014z"
}));

var SvgListaDeAtendimento = function SvgListaDeAtendimento(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListaDeAtendimento, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lista-de-atendimento.1a85fb01.svg";
export { ForwardRef as ReactComponent };